module.exports = __webpack_public_path__ + "img/article-thumb-1.2fd7d22c.png";